// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qcfs","content":"styles_content__4EGRx"};